<gn-alerts [domain]="domain" *ngIf="!!alertsUrl" [alertsUrl]="alertsUrl">
</gn-alerts>


<div data-qa="gn-account-links" class="btn-group dropdown" *ngIf="accountLinks.length > 0">
  <button type="button" class="btn btn-primary dropdown-toggle1 noborder" id="dropdownMenu" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false">
    <span class="pre-username">
      <span class="fa fa-user">&nbsp;</span>Hi, </span>
    <span id="username">{{userName}}</span>
    <span class="post-username">&nbsp;
      <span class="fa fa-caret-down"></span>
    </span>
  </button>
  <ul class="dropdown-menu account-dropdown" role="menu">
    <li *ngFor="let item of accountLinks; index as accIndex;">
      <a [attr.data-qa]="'gn-account-link-'+accIndex" href="{{item.url}}" role="menuitem">{{item.title}}</a>
    </li>
  </ul>
</div>
<div class="non-links" *ngIf="accountLinks.length == 0">
  <span class="pre-username">
    <span class="fa fa-user">&nbsp;</span>Hi, </span>
  <span id="username">{{userName}}</span>
</div>
